import React from 'react';
import HeaderCell from './header-cell'
import { oneDecimal } from '../../helpers/formatters'
import styles from './region-entity-table.module.scss';

export const EntityTableHeader = ({ entity, comparing }) => {
    return (
        <tr>
            <td className={styles.tableHeaderText}>{comparing ? entity.name : 'Summary'}</td>
            <td><HeaderCell label={"campuses**"} value={entity.numCampuses} /></td>
            <td><HeaderCell label={entity.name.includes('TAFE') ? "students" : "students (EFTSL)"} value={oneDecimal(entity.numStudents)} /></td>
            <td><HeaderCell label={"staff (fte)"} value={oneDecimal(entity.numEmployees)} /></td>
        </tr>
    )
}


// WEBPACK FOOTER //
// ./src/components/region-entity-table/entity-table-header.js